import React from 'react'
import { SkipLink as BrSkipLink } from "@vwfs-bronson/bronson-react";

interface Props {
    id: string;
  }
  
  export const SkipLink: React.FC<Props> = ({ id }) => {
    return <BrSkipLink href={`#${id}`} label="Zum Hauptinhalt springen" />;
  };
  